<template>
  <div class="d-flex">
    <v-icon class="float-left">
      mdi-chevron-left
    </v-icon>
    <v-breadcrumbs
      class="float-left pa-0 breadcrumbs"
      :items="items"
      :divider="divider"
    />
  </div>
</template>

<script>
export default {
  props: {
    divider: {
      type: String,
      default: '/'
    },
    items: {
      type: Array,
      default: () => [],
    }
  }
}
</script>

<style scoped>
.breadcrumbs >>> a {
  color: var(--v-textBody-base);
}
.breadcrumbs >>> a:hover {
  color: var(--v-primary-base);
}
.breadcrumbs >>> .v-breadcrumbs__item--disabled {
  color: var(--v-secondary-base) !important;
  font-weight: 600;
}
</style>
